'use client'
import React from 'react'
import { InputText } from '../InputText'
import styles from './styles.module.scss'
import { useTranslations } from 'next-intl'

const PromoCodeAndBonus = props => {
  const t = useTranslations('translation')
  const [isOpen, setIsOpen] = React.useState(Boolean(props.value))

  React.useEffect(() => {
    if (props.value) {
      setIsOpen(true)
    }
  }, [props.value])

  return (
    <div className={isOpen ? styles.container : styles.containerCollapsed}>
      <button
        className={styles.labelButton}
        onClick={() => setIsOpen(true)}
        type="button"
      >
        <span className={styles.label}>{t('iHavePromocode')}</span>
      </button>
      <div className={isOpen ? styles.contentOpen : styles.contentClosed}>
        <InputText {...props} />
      </div>
    </div>
  )
}

export default PromoCodeAndBonus
